import { maxFileBytes, megabytesLabel } from "@/lib/uploadLimits"

/** Upload rules for the OIO and OIA Simulators: PDF, DOCX, XLSX, PNG or JPEG, up to 50 MB each. */
export const SIM_ACCEPT =
  ".pdf,.docx,.xlsx,.png,.jpg,.jpeg,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,image/png,image/jpeg"
export const SIM_MAX_BYTES = 50 * 1024 * 1024
export const SIM_FILE_TYPE_MESSAGE = "Only PDF, DOCX, XLSX, PNG or JPEG files can be uploaded."
export const SIM_FILE_SIZE_MESSAGE = "Each file must be 50 MB or smaller."

const TYPE_OK = /\.(pdf|docx|xlsx|png|jpe?g)$/i

/** Split picked files into the ones to upload and a message explaining any that were refused. */
export function filterSimFiles(picked: File[]): { files: File[]; message: string } {
  const limit = maxFileBytes(SIM_MAX_BYTES)
  const typed = picked.filter((f) => TYPE_OK.test(f.name))
  const files = typed.filter((f) => f.size <= limit)
  const sizeMessage = limit === SIM_MAX_BYTES ? SIM_FILE_SIZE_MESSAGE : `Each file must be ${megabytesLabel(limit)} or smaller.`
  const message = typed.length < picked.length ? SIM_FILE_TYPE_MESSAGE : files.length < typed.length ? sizeMessage : ""
  return { files, message }
}
